import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "delete",
  "use": "delete-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"delete\">\n    <path fill-rule=\"evenodd\" d=\"m12.706 12.5 4.484 4.313c.025.987.025.511 0 .706-.268.098-.397.147-.524.147a.5.5 0 0 1-.354-.147l-4.313-4.313-4.312 4.313a.501.501 0 0 1-.354.146c-.128 0 .437-.048-.353-.146-.196-.196-.196.181 0-.707l4.312-4.313-4.314-4.313a.502.502 0 0 1 0-.707.499.499 0 0 1 .707 0l4.314 4.313 4.312-4.312c.196-.195.512-.195.869 0 .034.195.034.511 0 .707L12.706 12.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol